import { render, staticRenderFns } from "./StudentSiblingReport.vue?vue&type=template&id=62a6620a&scoped=true"
import script from "./StudentSiblingReport.vue?vue&type=script&lang=js"
export * from "./StudentSiblingReport.vue?vue&type=script&lang=js"
import style0 from "./StudentSiblingReport.vue?vue&type=style&index=0&id=62a6620a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a6620a",
  null
  
)

export default component.exports